/* Copyright (c) 2017 Backpack Health LLC */

import PropTypes from 'prop-types';

export const IconSizeNameProps = PropTypes.oneOf(['10', '11', '12', '13', '14', '16', '20', '24', '30', '32', '36', '56', '76', '100', '200']);

const IconSizeNames = {
  10: '10px',
  11: '11px',
  12: '12px',
  13: '13px',
  14: '14px',
  16: '16px',
  20: '20px',
  24: '24px',
  30: '30px',
  32: '32px',
  36: '36px',
  56: '56px',
  72: '72px',
  76: '76px',
  100: '100px',
  200: '200px',
};

export default IconSizeNames;
